import React from 'react';
import { SEAT_LABELS } from '../utils/tableSeats';

function deltaClass(delta) {
  if (delta > 0) return 'spades-hand-delta--pos';
  if (delta < 0) return 'spades-hand-delta--neg';
  return '';
}

function formatDelta(delta) {
  if (delta == null) return '—';
  return delta > 0 ? `+${delta}` : String(delta);
}

function occupantLabel(occ) {
  if (!occ) return '—';
  return occ.username || occ.botLabel || '?';
}

function HeartsHandResults({
  handResults,
  seats,
  isHost,
  onNextHand,
  floating = false,
}) {
  if (!handResults || handResults.gameType !== 'hearts') return null;

  const { handNumber, players, moonShooter } = handResults;

  const panelClass = [
    'spades-bid-panel',
    'spades-hand-results-panel',
    floating ? 'spades-bid-panel--float' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={panelClass} role="dialog" aria-label="Hand results">
      <p className="spades-bid-prompt">Hand {handNumber} complete</p>
      {moonShooter && (
        <p className="hearts-moon-banner">
          {occupantLabel(seats?.[moonShooter])} shot the moon!
        </p>
      )}
      <ul className="spades-hand-results-list">
        {['north', 'east', 'south', 'west'].map((seat) => {
          const occ = seats?.[seat];
          if (!occ) return null;
          const ps = players?.[seat];
          if (!ps) return null;
          return (
            <li key={seat} className="spades-hand-results-row">
              <span className="spades-hand-results-name">
                {occupantLabel(occ)}
                <span className="spades-hand-results-seat">{SEAT_LABELS[seat]}</span>
              </span>
              <span className={['spades-hand-results-delta', deltaClass(ps.delta)].join(' ')}>
                {formatDelta(ps.delta)}
              </span>
              <span className="spades-score-value">{ps.score}</span>
            </li>
          );
        })}
      </ul>
      {isHost && (
        <div className="spades-host-actions">
          <button
            type="button"
            className="spades-bid-btn spades-bid-btn--primary spades-host-btn--wide"
            onClick={onNextHand}
          >
            Next hand
          </button>
        </div>
      )}
      {!isHost && (
        <p className="spades-bid-prompt">Waiting for host to deal…</p>
      )}
    </div>
  );
}

export default HeartsHandResults;
